import { BorderOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import Modal from 'antd/lib/modal/Modal';
import { autobind } from 'core-decorators';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { PureComponent } from 'react';
import { TableController } from '../../controls/TableController';
import { admin_fetchChains } from '../../lib/api-web';
import modals from '../../stores/modals';
import { Sorting } from '../../web-types/Sorting';

export interface SelectChainModalProps {
	defaultChainId?: number | null;
	onDismiss: () => void;
	onConfirm: (chainId: number) => void;
}

@observer
export default class SelectChainModal extends PureComponent<SelectChainModalProps> {
	static async show(defaultChainId?: number | null): Promise<number | null> {
		return new Promise<number | null>(resolve => {
			modals.show((close: () => void) => (
				<SelectChainModal
					defaultChainId={defaultChainId}
					onDismiss={() => {
						close();
						resolve(null);
					}}
					onConfirm={chainId => {
						close();
						resolve(chainId);
					}}
				/>
			));
		});
	}

	@observable contentVisible = false;
	@observable total: number | null = null;
	@observable params: { query: string } = { query: '' };
	@observable selected: number | null = this.props.defaultChainId || null;

	@autobind
	handleTablePropsUpdate(contentVisible: boolean, total: number | null, rowsPerPage: number) {
		this.contentVisible = contentVisible;
		this.total = total;
	}

	@autobind
	async handleLoad(params: { query: string }, offset: number, limit: number, sorting: Sorting | null) {
		return admin_fetchChains(offset, limit, {
			query: params.query,
			sorting: sorting || null,
		});
	}

	render() {
		return (
			<Modal
				title="Select chain"
				onCancel={() => this.props.onDismiss()}
				visible={true}
				closable={false}
				okButtonProps={{
					disabled: !this.selected,
				}}
				onOk={() => {
					this.props.onConfirm(this.selected!);
				}}
			>
				<Input.Search
					style={{ marginBottom: 15 }}
					type="search"
					onSearch={value => (this.params.query = value)}
					placeholder="Search chain..."
				/>
				<TableController
					onRowClick={({ id }) => {
						this.selected = id;
					}}
					noSection
					params={this.params}
					load={this.handleLoad}
					onTablePropsUpdate={this.handleTablePropsUpdate}
					rowClass={({ id }) => (this.selected === id ? 'row-selected' : 'dummy-class')}
					columns={[
						{
							key: 'logoUrl',
							title: '',
							render: value => <Avatar size={30} src={value} icon={<BorderOutlined />} />,
							width: 50,
						},
						{
							key: 'name',
							title: 'Name',
							sortable: true,
							render: (value, row) => `${row.name}`,
						},
					]}
				/>
			</Modal>
		);
	}
}
